import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  TREATMENT_OPTIONS,
  TREATMENT_OPTIONS_TYPE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const vcuhealth: GetCustomerCopyFunc = () => {
  const vcuHealthProviderConfiguration = {
    analyticsName: 'VCU Health System',
    title: (
      <FormattedMessage
        defaultMessage='VCU Health System'
        description='Title for VCU Health System provider when shown as a treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='If you would like to see a VCU Health provider, you may schedule directly by calling this number (804) 828-4327 between the hours of 8am - 5pm ET'
        description='Description for VCU Health provider scheduling information'
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Connect with a VCU Health System Provider'
        description='Button text to connect with a VCU Health System provider'
      />
    ),
    url: 'tel:8048284327',
  }

  return {
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: {
          customCopy: vcuHealthProviderConfiguration,
          key: 'vcu_health_provider',
        },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 1,
          seeMore: 1,
        },
        displayRules: {
          showForTiers: [TREATMENT_RECOMMENDATION_TIER.TIER_2, TREATMENT_RECOMMENDATION_TIER.TIER_3],
          showForTreatmentOptions: [
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY,
            TREATMENT_OPTIONS.BLENDED_CARE_THERAPY,
            TREATMENT_OPTIONS.FAMILY_THERAPY,
            TREATMENT_OPTIONS.COUPLES_THERAPY,
            TREATMENT_OPTIONS.ONSITE_THERAPY,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD,
            TREATMENT_OPTIONS.FAMILY_THERAPY_CHILD,
            TREATMENT_OPTIONS.ALCOHOL_USE_DISORDER,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_ICAS_PHONE,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD_ICAS_PHONE,
            'familyTherapyICASPhone',
            'couplesTherapyICASPhone',
          ] as (TREATMENT_OPTIONS_TYPE | 'familyTherapyICASPhone' | 'couplesTherapyICASPhone')[],
        },
      },
    ],
  }
}
